import React from 'react'
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../common/components/form/input/containers/input.container';

export default function GlobalDbnBluePrintRegistriesBasicInfoComponent({
    handleInnerFormChange,
    selectedCategory,
    RoutingModels,LifeCycleStatus
}: any) {
    return (
        <>
            <AccordionContainer
                headerTitle="New Service Category Group"
                expandedPanel="userInfo"
                child={
                    <div className="grid md:grid-cols-2 gap-4">

                        <div className="text-black">
                            <InputContainer
                                label="Routing Model"
                                labelField="Name"
                                list={RoutingModels}
                                type="select"
                                 isDisabled={!!selectedCategory?.GlobalBluePrintRegistryId}
                                optionName="Select Routing Model"
                                value={selectedCategory?.GlobalDBNRoutingModelId}
                                valueField="GlobalDBNRoutingModelId"
                                onValueChange={(event: any) => {
                                    handleInnerFormChange(
                                        Number(event.target.value),
                                        "GlobalDBNRoutingModelId"
                                    );
                                }}
                            />
                        </div>
                           <div className="text-black">
                            <InputContainer
                                label="LifeCycle Status"
                                labelField="Text"
                                list={LifeCycleStatus}
                                type="select"
                                optionName="Select Plan Type"
                                value={selectedCategory?.LifeCycleStatusId}
                                valueField="Value"
                                onValueChange={(event: any) => {
                                    handleInnerFormChange(
                                        Number(event.target.value),
                                        "LifeCycleStatusId"
                                    );
                                }}
                            />
                        </div> 
                        <div className="md:col-span-2">
                            <InputContainer
                                label="Description"
                                name="Description"
                                type="text"
                                value={selectedCategory?.Description}
                                onValueChange={(event: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'Description'
                                    );
                                }}
                            />
                        </div>

                    </div>
                }
            />
        </>
    );
}